const datasources: Record<string, any> = {};
export default datasources;